'use strict';
var util = require('../util');

module.exports = {
  appVersion: '7.5.0',
  
  store: function(opt) {
    var bizname = this._getBizName(opt);
    if (bizname) {
      opt.key = bizname + ':' + opt.key;
      this._send('store', opt);
    }
  },
  retrieve: function(opt) {
    var bizname = this._getBizName(opt);
    if (opt.key.indexOf(':') === -1) {
      opt.key = bizname + ':' + opt.key;
    }
    this._send('retrieve', opt);
  },
  setBackgroundColor: util.actionMapping('setBackgroundColor')
};


//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@dp/dpapp/lib/patch/patch-7.5.0.js
// module id = 548
// module chunks = 0